import { ERROR_MESSAGES, SERVER_RESPONSE } from "../util/NotificationMessages";
import { retryConfigDefaults } from "../Constants";

export const getApiUrl = (endpoint) => {
    if (process.env.NODE_ENV !== "production") {
    return "http://localhost:7071" + endpoint;
  } else {
    return endpoint;
  }
};

export const handleApiResponse = (responseData) => {
  const { code, error } = responseData.status;
  if (code !== 200) {
    throw new Error(error);
  }
  return responseData.result;
};

export const getResource = async (endpoint) => {
  const url = getApiUrl(endpoint);
  try {
    const response = await fetchWithRetry(url, {
      method: "GET",
    });

    const data = await response.json();

    if (!response.ok) {
      const errorMessage =
        data.status?.error.includes(SERVER_RESPONSE.RESOURCE_NOT_FOUND) ?
          ERROR_MESSAGES.RESOURCE_NOT_FOUND
        : ERROR_MESSAGES.GENERIC_ERROR;
      throw new Error(errorMessage);
    }

    return data;
  } catch (error) {
    if (error.message.includes(SERVER_RESPONSE.NETWORK_ERROR)) {
      console.error("Fetch failed:", error);
      throw new Error(ERROR_MESSAGES.NETWORK_ERROR);
    }
    throw error;
  }
};

export async function fetchWithRetry(url, options= {}, config = retryConfigDefaults) {
  let lastError = null;

  for (let attempt = 0; attempt <= config.maxRetries; attempt++) {
    try {
      const response = await fetch(url, options);

      if (response.ok || !config.retryableStatuses.includes(response.status)) {
        return response;
      }
    } catch (err) {
      lastError = err instanceof Error ? err : new Error(String(err));
      console.log(`Route: ${url} Attempt ${attempt + 1} failed with network error. Retrying...`);
    }

    if (attempt < config.maxRetries) {
      const delay = config.initialDelay * Math.pow(2, attempt) + (Math.random() * 100); // exponential delay
      
      await new Promise((resolve) => setTimeout(resolve, delay));
    }
  }
  throw lastError || new Error(`Failed after ${config.maxRetries} retries.`);
}